import { render, staticRenderFns } from "./MlopsProjects.vue?vue&type=template&id=c9e7478e&lang=pug"
import script from "./MlopsProjects.vue?vue&type=script&lang=js"
export * from "./MlopsProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9e7478e')) {
      api.createRecord('c9e7478e', component.options)
    } else {
      api.reload('c9e7478e', component.options)
    }
    module.hot.accept("./MlopsProjects.vue?vue&type=template&id=c9e7478e&lang=pug", function () {
      api.rerender('c9e7478e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/analytic-services/components/MlopsProjects.vue"
export default component.exports